import React from 'react';
import { EnvironmentContext, MetricsContextProvider } from '../context';
import { ForgeUIAnalyticsListener } from '../analytics';
export var ForgeUIExtensionPointProvider = function ForgeUIExtensionPointProvider(_ref) {
  var analyticsWebClient = _ref.analyticsWebClient,
    environment = _ref.environment,
    product = _ref.product,
    page = _ref.page,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(EnvironmentContext.Provider, {
    value: environment
  }, /*#__PURE__*/React.createElement(MetricsContextProvider, {
    value: {
      product: product,
      page: page
    }
  }, /*#__PURE__*/React.createElement(ForgeUIAnalyticsListener, {
    client: analyticsWebClient,
    commonAttributes: {
      moduleType: page
    }
  }, children)));
};